import { fundingHqFetch } from './fundingApi';

function agencyQuery(agencyId) {
  const params = new URLSearchParams({ agency_id: agencyId });
  return params.toString();
}

export async function createFundingSequence(clientId, agencyId, payload) {
  return fundingHqFetch(
    `/clients/${encodeURIComponent(clientId)}/sequences?${agencyQuery(agencyId)}`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    },
  );
}

export async function generateFundingSequence(clientId, agencyId, options = {}) {
  const params = new URLSearchParams({ agency_id: agencyId });
  if (options.strategyType) params.set('strategy_type', options.strategyType);
  if (options.includeNotReady) params.set('include_not_ready', 'true');

  return fundingHqFetch(
    `/clients/${encodeURIComponent(clientId)}/sequences/generate?${params.toString()}`,
    { method: 'POST' },
  );
}

export async function fetchFundingSequences(clientId, agencyId) {
  const data = await fundingHqFetch(
    `/clients/${encodeURIComponent(clientId)}/sequences?${agencyQuery(agencyId)}`,
  );
  return {
    sequences: data.sequences ?? [],
    total: data.total ?? (data.sequences?.length ?? 0),
  };
}

export async function fetchFundingSequencesList({ agencyId, limit = 50 } = {}) {
  const params = new URLSearchParams();
  if (agencyId) params.set('agency_id', agencyId);
  if (limit) params.set('limit', String(limit));
  const query = params.toString();
  const data = await fundingHqFetch(`/sequences${query ? `?${query}` : ''}`);
  return {
    sequences: data.sequences ?? [],
    total: data.total ?? (data.sequences?.length ?? 0),
  };
}

export async function fetchFundingSequence(sequenceId, agencyId) {
  return fundingHqFetch(
    `/sequences/${encodeURIComponent(sequenceId)}?${agencyQuery(agencyId)}`,
  );
}

export async function updateFundingSequence(sequenceId, agencyId, payload) {
  return fundingHqFetch(
    `/sequences/${encodeURIComponent(sequenceId)}?${agencyQuery(agencyId)}`,
    {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    },
  );
}

export async function updateFundingSequenceItem(sequenceId, itemId, agencyId, payload) {
  return fundingHqFetch(
    `/sequences/${encodeURIComponent(sequenceId)}/items/${encodeURIComponent(itemId)}?${agencyQuery(agencyId)}`,
    {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    },
  );
}

export async function reorderFundingSequenceItems(sequenceId, agencyId, items) {
  return fundingHqFetch(
    `/sequences/${encodeURIComponent(sequenceId)}/items/reorder?${agencyQuery(agencyId)}`,
    {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items }),
    },
  );
}

export async function addMatchToSequence(matchId, agencyId, sequenceId) {
  return fundingHqFetch(`/matches/${encodeURIComponent(matchId)}/sequence`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      agency_id: agencyId,
      sequence_id: sequenceId || undefined,
    }),
  });
}
